import { render, staticRenderFns } from "./statistics_menu.vue?vue&type=template&id=0f8f72d2"
import script from "./statistics_menu.vue?vue&type=script&lang=js"
export * from "./statistics_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports